// src/pages/Stocks/StockCategory.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { stockService } from '../../services/stockService';
import StockSearch from './components/StockSearch/StockSearch';
import StockGrid from './components/StockGrid/StockGrid';
import { useCurrency } from '../../context/CurrencyContext'; // ADD THIS
import './StockCategory.css';

const StockCategory = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const { currency } = useCurrency(); // ADD THIS
  const [stocks, setStocks] = useState([]);
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategoryStocks = async () => {
      try {
        setLoading(true);
        const categoryStocks = await stockService.getStocksByCategory(category);
        setStocks(categoryStocks);
        setFilteredStocks(categoryStocks);
      } catch (err) {
        setError(err.message || 'Failed to fetch category stocks');
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryStocks();
  }, [category, currency]); // ADD currency dependency

  const handleSearch = (term) => {
    setSearchTerm(term);
    if (!term.trim()) {
      setFilteredStocks(stocks);
      return;
    }

    const filtered = stocks.filter(stock =>
      stock.symbol.toLowerCase().includes(term.toLowerCase()) ||
      stock.name.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredStocks(filtered);
  };

  const getCategoryTitle = () => {
    switch(category) {
      case 'ng-stocks': return 'Core NG Assets';
      case 'private-equity': return 'Private Equity Assets';
      case 'pre-ipo': return 'Scale-Up Assets';
      case 'fpo': return 'Growth Round Assets';
      default: return 'Assets';
    }
  };

  const getCategoryDescription = () => {
    switch(category) {
      case 'ng-stocks': return 'Listed assets on Trexar';
      case 'private-equity': return 'Private equity investment opportunities';
      case 'pre-ipo': return 'Scale-Up assets before public listing';
      case 'fpo': return 'Growth Rounds assets';
      default: return 'Explore and trade available assets';
    }
  };

  if (loading) {
    return (
      <div className="stock-category-container">
        <div className="stocks-loading">Loading {getCategoryTitle().toLowerCase()}...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stock-category-container">
        <div className="stocks-error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="stock-category-container">
      {/* Header with back button */}
      <div className="category-header">
        <button 
          className="back-button"
          onClick={() => navigate('/stocks')}
        >
          ← Back to Categories
        </button>
        <div className="category-title-section">
          <h1>{getCategoryTitle()}</h1>
          <p>{getCategoryDescription()}</p>
          <div className="stocks-count">
            {filteredStocks.length} {filteredStocks.length === 1 ? 'asset' : 'assets'} available
            <span className="currency-display"> • Displaying in {currency}</span>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="category-search">
        <StockSearch onSearch={handleSearch} />
      </div>

      {/* Stocks Grid */}
      <StockGrid 
        stocks={filteredStocks} 
        searchTerm={searchTerm}
      />
    </div>
  );
};

export default StockCategory;